 
import {
    SET_SHOW_FIND_POSITION,
    SET_SHOW_FIND_POSITION_DATA
} from '../types'; 



/**
 * 是否顯示 Position list
 * */
export const setFindPositionTargetData = (result) => dispatch => {
    
    dispatch({
        type: SET_SHOW_FIND_POSITION_DATA,
        payload: result
    });
 
}
/**
 * 是否顯示 Position list
 * */
export const showHidePositionList = (result) => dispatch => {
    
    dispatch({
        type: SET_SHOW_FIND_POSITION,
        payload: result
    });
 
}




// WEBPACK FOOTER //
// ./src/actions/find/positionFindAction.js